import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  search_icon,
  view_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import {
  useLazyTotalLocationsListQuery,
  usePropertiesBlockedDatesMutation,
  usePropertiesBlockMutation,
  usePropertiesListMutation,
  usePropertiesStatusMutation,
} from "../redux/api/api";
import moment from "moment/moment";
import CustomSearchSelect from "../../components/Searchbox/CustomSearch";
import { toast } from "react-toastify";
import { Modal, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import CloseIcon from "@mui/icons-material/Close";
import "react-datepicker/dist/react-datepicker.css";

const Property = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  const [fromdate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const [pageno, setPageno] = useState(1);
  const [pagecount, setPagecount] = useState("");
  const [show, setShow] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [count, setCount] = useState();
  const [cities, setCities] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [loading, setLoading] = useState(false);
  const [locationLoader, setLocationLoader] = useState(false);
  const [listData, setListData] = useState({});

  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState("");
  const [blockedDates, setBlockedDates] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);


  const rolePermissions = JSON.parse(localStorage.getItem('permissions'))

  //RTK
  const [getListApi] = usePropertiesListMutation();
  const [getCityApi] = useLazyTotalLocationsListQuery();
  const [statusChangeApi] = usePropertiesStatusMutation();
  const [propertiesBlockedDatesApi] = usePropertiesBlockedDatesMutation();
  const [propertiesBlockApi] = usePropertiesBlockMutation();

  const handleShow = (data) => {
    let formdata = new FormData();
    formdata.append("property_id", data?.id);
    propertiesBlockedDatesApi(formdata)
      .unwrap()
      .then((res) => {
        let temp = [];
        if (
          Array.isArray(res?.blocked_dates) &&
          res?.blocked_dates?.length > 0
        ) {
          res?.blocked_dates?.map((item, ind) => {
            temp.push(new Date(item));
          });
        } else if (Object.keys(res?.blocked_dates)?.length > 0) {
          Object.keys(res?.blocked_dates)?.map((item, ind) => {
            temp.push(new Date(item));
          });
        }
        setBlockedDates(temp);
        setListData(data);
        setShow(true);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleClose = () => {
    setBlockedDates([]);
    setListData({});
    setMinDate(new Date());
    setMaxDate("");
    setStartDate(null);
    setEndDate(null);
    setShow(false);
  };

  const areDatesSame = (date1, date2) => {
    return (
      new Date(date1).toISOString().split("T")[0] ===
      new Date(date2).toISOString().split("T")[0]
    );
  };

  const getDayBefore = (dateInput) => {
    const date = new Date(dateInput);
    date.setDate(date.getDate() - 1);
    return date.toISOString().split("T")[0];
  };

  const onChange = (dates) => {
    const [start, end] = dates;

    // CHECKING IF SELECED DATE IS SAME
    let sameDate = areDatesSame(start, end);

    // ACCENDING ODER
    let date_ = blockedDates?.sort((a, b) => a - b);

    // FINDING THE DATE WHICH IS GREATER THAN SATART DATE
    const earlierDates = date_.find((date) => start < date);

    if (earlierDates) {
      // YESTERDAY GETTING METHOD
      let start_before = getDayBefore(start);
      let end_before = getDayBefore(earlierDates);

      if (sameDate) {
        setMinDate(new Date());
        setMaxDate("");
      } else {
        setMinDate(moment(start).format("YYYY/MM/DD"));
        setMaxDate(moment(end_before).format("YYYY/MM/DD"));
      }
    } else {
      if (sameDate) {
        setMinDate(new Date());
        setMaxDate("");
      } else {
        setMinDate(moment(start).format("YYYY/MM/DD"));
        setMaxDate("");
      }
    }

    setStartDate(start);
    setEndDate(end);
    // "2025/04/28" format
  };

  const checkDateInRange = (dateToCheck, startDate, endDate) => {
    console.log("dateToCheck", dateToCheck);

    const date = new Date(dateToCheck);
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (date < start) {
      console.log("After range");
    } else if (date > start) {
      console.log("Before range");
    } else {
      console.log("Within range");
    }
  };

  const blockProperty = () => {
    if (!startDate) {
      toast.error("Please Enter Date to Block")
      return
    }
    let formdata = new FormData();
    formdata.append("property_id", listData?.id);
    formdata.append("from_date", moment(startDate).format("YYYY-MM-DD"));
    if (endDate != null) {
      formdata.append("to_date", moment(endDate).format("YYYY-MM-DD"));
    } else {
      formdata.append("to_date", moment(startDate).format("YYYY-MM-DD"));
    }
    formdata.append("block_type", 1);
    propertiesBlockApi(formdata)
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getList(
            fromdate,
            toDate,
            selectedCityId,
            search,
            type,
            status,
            pageno
          );
          handleClose();
        } else {
          toast.error(res?.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };



  const getLocations = () => {
    setLocationLoader(true);
    getCityApi()
      .unwrap()
      .then((res) => {
        console.log(res);
        let temp = res?.data?.filter((item) => item?.type == 3);
        setCities(temp);
        setLocationLoader(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getList = (
    fromdate,
    toDate,
    selectedCityId,
    search,
    type,
    status,
    pageno
  ) => {
    let formdata = new FormData();
    if (fromdate && toDate) {
      formdata.append("from_date", moment(fromdate).format("YYYY-MM-DD"));
      formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    }

    if (selectedCityId) {
      formdata.append("city", selectedCityId);
    }
    if (type) {
      formdata.append("property_type", type);
    }
    if (status) {
      formdata.append("status", status);
    }
    if (search) {
      formdata.append("search", search);
    }

    formdata.append("page", pageno);
    formdata.append("row", 10);
    setFromDate(fromdate);
    setToDate(toDate);
    setSelectedCityId(selectedCityId);
    setType(type);
    setStatus(status);
    setSearch(search);

    getListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log(res);
        let temp = [];
        res?.data?.map((item, ind) => {
          let obj = { ...item };
          obj.current_page = res?.pagination?.current_page;
          temp.push(obj);
        });
        setList(temp);
        setPagecount(res?.pagination);
        setCount(res?.pagination?.total);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getList(fromdate, toDate, selectedCityId, search, type, status, pageno);
    getLocations();
  }, [pageno]);

  const handleStatus = (id, e) => {
    setLoading(true);
    console.log("idn", id, "event", e);
    let formdata = new FormData();
    formdata.append("status", e);
    formdata.append("id", id);
    statusChangeApi(formdata)
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          getList(fromdate, toDate, selectedCityId, search, type, status, pageno);
          toast.success(res?.message);
        }
      })
      .catch((err) => {
        if (err?.status == "error") {
          toast.error(err?.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <p>{(row?.original?.current_page - 1) * 10 + row.index + 1}</p>
          );
        },
      },
      {
        Header: "Property Id",
        accessor: "property_id",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/property-view", {
                    state: { data: row.original },
                  })
                }
              >
                {value}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Property Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/property-view", {
                    state: { data: row.original },
                  })
                }
              >
                {value}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Owner Name",
        accessor: "owner",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/owner-view", {
                    state: { type: "view", id: row.original.owner_id },
                  })
                }
              >
                {value?.name}
              </p>
            </div>
          );
        },
      },

      {
        Header: "Type",
        accessor: "property_type",
        Cell: ({ value, row }) => {
          return <p>{value == 1 ? "Rooms" : "Individual"}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{value?.name}</p>;
        },
      },
      {
        Header: "Block",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <button
              onClick={() => handleShow(row.original)}
              className="cust-btn susp-btn"
            >
              <p className="mb-0">Block</p>
            </button>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          const [status, setStatus] = useState(value);

          const handleChange = (e) => {
            setStatus(e.target.value);
            handleStatus(row?.original?.id, e.target.value);
          };

          return (
            <React.Fragment>
              {status == 4 ? (
                <p className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 blocked-btn mb-0 d-flex ac-jc">
                  Suspend
                </p>
              ) : (
                // status == 3 ? (
                //   <p className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 blocked-btn mb-0 d-flex ac-jc">Not Verified</p>
                // ) :
                <select disabled={rolePermissions?.includes('CAN-STATUS-PROPERTY') ? false : true}
                  value={value}
                  onChange={(e) => handleStatus(row?.original?.id, e.target.value)}
                  className={`fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 ${value == 1
                    ? "active-btn"
                    : value == 2
                      ? "suspend-btn"
                      : ""
                    }`}
                >
                  <option
                    className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black"
                    value={1}
                  >
                    Active
                  </option>
                  <option
                    className="fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 bg-white black"
                    value={2}
                  >
                    Deactive
                  </option>
                </select>
              )}
            </React.Fragment>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                {rolePermissions?.includes('CAN-VIEW-PROPERTY') &&
                  <button
                    onClick={() =>
                      navigate("/property-view", {
                        state: { data: row.original },
                      })
                    }
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                  </button>
                }
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );

  const clearBtn = () => {
    setMinDate(new Date());
    setMaxDate("");
    setStartDate(null);
    setEndDate(null);
  };

  return (
    <div className="dashRightView home_section">
      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
        Property({count})
      </h2>
      <div className="d-flex ac-jb mt-4">
        <div className="d-flex ac-js gap-2">
          <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary">
            From Date
          </label>
          <div className="w-15">
            <DatePicker
              selected={fromdate}
              onChange={(e) =>
                getList(e, toDate, selectedCityId, search, type, status, 1)
              }
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="From Date"
              type="date"
            />
          </div>
          <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary">
            To Date
          </label>
          <div className="w-15">
            <DatePicker
              type="date"
              dateFormat="dd-MM-yyyy"
              className="input-pop-new ps-2 w-100"
              placeholderText="To Date"
              selected={toDate}
              onChange={(e) =>
                getList(fromdate, e, selectedCityId, search, type, status, 1)
              }
            />
          </div>
          <label className="f2 fs-sm-8 fs-md-14 fs-lg-16 fs-xl-16 fs-xxl-18 primary">
            City
          </label>

          <CustomSearchSelect
            options={cities}
            value={selectedCityId}
            onChange={(value) => {
              getList(fromdate, toDate, value, search, type, status, pageno);
            }}
            placeholder="Select City"
            width="200px"
            locationLoader={locationLoader}
          />
        </div>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              value={search}
              onChange={(e) =>
                getList(
                  fromdate,
                  toDate,
                  selectedCityId,
                  e.target.value,
                  type,
                  status,
                  pageno
                )
              }
            />
            <img src={search_icon} className="search" />
          </div>
          {rolePermissions?.includes('CAN-ADD-PROPERTY') &&
            <button
              onClick={() => navigate("/property-add")}
              className="f2 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 white add-btn "
            >
              <AddIcon className="f3 fs-sm-10 fs-md-11 fs-lg-12 fs-xl-14 fs-xxl-16 " />{" "}
              Add{" "}
            </button>}
        </div>
      </div>
      <div className="d-flex ac-js gap-3 mt-4">
        <select
          type="date"
          className="search-input ps-2 col-md-2"
          placeholder="Select type"
          onChange={(e) =>
            getList(
              fromdate,
              toDate,
              selectedCityId,
              search,
              e.target.value,
              status,
              pageno
            )
          }
        >
          <option value="">All</option>
          <option value="1">Rooms</option>
          <option value="2">Individual</option>
        </select>
        <select
          type="date"
          className="search-input ps-2 col-md-2"
          placeholder="select status"
          onChange={(e) =>
            getList(
              fromdate,
              toDate,
              selectedCityId,
              search,
              type,
              e.target.value,
              pageno
            )
          }
        >
          <option value="">All</option>
          <option value="1">Active</option>
          <option value="2">Deactive</option>
          <option value="3">Suspended</option>
        </select>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <div className="p-4">
          <div className="p-1">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-22 sec ">
                Block
              </h2>
              <button
                className="border-0 bg-transparent"
                onClick={() => handleClose()}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="mt-3">
              <h2 className="f3 fs-sm-18 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-22  text-center">
                Select Dates to Block
              </h2>
              {startDate != null && (
                <div className="text-end">
                  <button className="cust-btn" onClick={() => clearBtn()}>
                    Clear
                  </button>
                </div>
              )}
              <div className="text-center">
                <DatePicker
                  selected={startDate}
                  onChange={onChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  selectsDisabledDaysInRange
                  minDate={minDate}
                  maxDate={maxDate}
                  inline
                  excludeDates={blockedDates}
                />
              </div>
            </div>


            <div className="col-md-12 d-flex ac-jc mt-3">
              <button
                className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                onClick={() => blockProperty()}
              >
                Block
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Table
        columns={columns}
        data={list}
        setPageno={setPageno}
        pagecount={pagecount}
        show={true}
      />
      {loading && (
        <div style={{ zIndex: 2000, position: "fixed", top: "45%", left: "49%", }}  >
          <Spinner animation="border" className="primary1" />
        </div>)}
    </div>
  );
};

export default Property;
